import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import WhenSection from '../components/WhenSection';
import ServicesSection from '../components/ServicesSection';
import EngagementSection from '../components/EngagementSection';
import MessageSection from '../components/MessageSection';
import CompanyInfoSection from '../components/CompanyInfoSection';
import NewsSection from '../components/NewsSection';
import ContactSection from '../components/ContactSection';
import SEOHead from '../components/SEOHead';
import { getSEOMetadataForRoute } from '../utils/seoMetadata';
import styles from './HomePage.module.css';
import { HEADER_HEIGHT } from '../styles/layoutConstants';

const SECTION_IDS = [
  'hero',
  'when',
  'services',
  'engagement',
  'message',
  'company-info',
  'news',
  'contact',
] as const;

const HomePage: React.FC = () => {
  const [activeSection, setActiveSection] = useState<string>('hero');
  const location = useLocation();
  const seoMetadata = getSEOMetadataForRoute('/');

  // ハッシュ付き URL（/#engagement など）で該当セクションへスクロール
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (!hash) return;
    const timer = setTimeout(() => {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setActiveSection(hash);
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [location.hash]);

  // スクロール位置から現在のセクションを判定
  useEffect(() => {
    const handleScroll = (): void => {
      const scrollPosition = window.scrollY + HEADER_HEIGHT + 20;
      for (const sectionId of SECTION_IDS) {
        const element = document.getElementById(sectionId);
        if (!element) continue;
        const { offsetTop, offsetHeight } = element;
        if (
          scrollPosition >= offsetTop &&
          scrollPosition < offsetTop + offsetHeight
        ) {
          setActiveSection(sectionId);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.homePage}>
      <SEOHead metadata={seoMetadata} currentPath="/" />
      <Header
        activeSection={activeSection}
        onSectionChange={setActiveSection}
      />
      <main id="main-content" className={styles.main}>
        <HeroSection />
        <WhenSection />
        <ServicesSection />
        <EngagementSection />
        <MessageSection />
        <CompanyInfoSection />
        <NewsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
